import request from "@/utils/request";

export function speciesGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Species/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function speciesCreate(data) {
    return request({
        url: "/api/services/app/Species/Create",
        method: "POST",
        data
    });
}

export function speciesUpdate(data) {
    return request({
        url: "/api/services/app/Species/Update",
        method: "PUT",
        data
    });
}

export function speciesDelete(params) {
    return request({
        url: "/api/services/app/Species/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/species.js